import Repository from '../../../../../foundation/repository/Repository';
import ApiData from '../../../../../foundation/repository/ApiData';
import Lesson from '../aggregates/lesson/Lesson';
import Position from '../aggregates/lesson/Position';
import Registry from '../../../../global/Registry';
import Course from '../aggregates/course/Course';

export default class LessonRepository extends Repository<Lesson> {

	public getAll () {
		return super.getAll().filter(lesson => lesson.isActive() || Registry.getInstance().me.isErik());
	}

	public mapObject (data: ApiData) {
		return new Lesson(
			data.id<Lesson>('id'),
			data.id<Course>('courseId'),
			data.string('title'),
			data.string('subtitle'),
			data.string('content'),
			data.boolean('active'),
			data.map('prerequisiteLessonIds', (data: ApiData) => data.id<Lesson>()),
			this.mapPosition(data.navigate('position'))
		);
	}

	private mapPosition (data: ApiData) {
		return new Position(
			data.number('x'),
			data.number('y')
		);
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/lessons/domain/repositories/LessonRepository.ts